import React from 'react';

export function SearchBox({ value, onChange, placeholder = 'Search...' }: SearchBoxProps) {
  return (
    <div className="w-full">
      <div className="flex w-full items-stretch">
        <div className="flex-1 relative z-10">
          <div
            className="
              overflow-hidden rounded-l-full bg-white
              border-2 border-transparent
              transition-all duration-150
              focus-within:border-[#9596B8]
              focus-within:ring-3 focus-within:ring-[#cacadb]/75
            "
          >
            <input
              type="text"
              placeholder={placeholder}
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="
                w-full px-6 py-4
                text-gray-700 placeholder-gray-400
                bg-white border-0 rounded-l-full
                outline-none focus:outline-none focus:ring-0
              "
            />
          </div>
        </div>

        <button
          type="button"
          className="shrink-0 -ml-2 rounded-r-full bg-[#CD1520] px-6 py-4 text-white"
          aria-label="Search"
        >
          <svg viewBox="0 0 21 21" className="h-6 w-6" aria-hidden="true">
            <g fill="none" fillRule="evenodd" stroke="currentColor" strokeWidth="2">
              <path d="M19 19l-5-5" strokeLinecap="square" />
              <circle cx="8.5" cy="8.5" r="7.5" />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
}

export interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}
